import { FaqContentType } from '@lib/data/faq'
import { LanguageContentType } from '@lib/types/geo-lp'
export const JAPANESE_FAQ: FaqContentType[] = [
  {
    questionName: `レッスンに必要な環境を教えてください ?`,
    acceptedAnswerText: (
      <>
        安定したインターネット環境（2Mbps以上）とカメラ付きのノートパソコンをご用意ください。特別なソフトウェアのインストールは不要です。
      </>
    ),
    acceptedAnswerTextString: `安定したインターネット環境（2Mbps以上）とカメラ付きのノートパソコンをご用意ください。特別なソフトウェアのインストールは不要です。`,
  },
  {
    questionName: `途中でコースを変更できますか？`,
    acceptedAnswerText: (
      <>
        {' '}
        はい、お子様の習熟度や興味に合わせてコース変更が可能です。専任カウンセラーがサポートいたします。
      </>
    ),
    acceptedAnswerTextString: ` はい、お子様の習熟度や興味に合わせてコース変更が可能です。専任カウンセラーがサポートいたします。`,
  },
  {
    questionName: `授業料の支払い方法は？`,
    acceptedAnswerText: (
      <>
        クレジットカード（VISA, MasterCard, American Express,
        JCB）でのお支払いに対応しています。
      </>
    ),
    acceptedAnswerTextString: `クレジットカード（VISA, MasterCard, American Express, JCB）でのお支払いに対応しています。`,
  },
  {
    questionName: `兄弟で申し込む場合の割引はありますか？`,
    acceptedAnswerText: (
      <> 兄弟姉妹割引もご用意しています。詳細はお問い合わせください。</>
    ),
    acceptedAnswerTextString: ` 兄弟姉妹割引もご用意しています。詳細はお問い合わせください。`,
  },
]

export const JAPANESE_CONTENT: LanguageContentType = {
  bookTrialClassCTA: '無料レッスンを予約',
  heroFold: {
    formatHeading() {
      return `Best online coding classes for kids in Japan`
    },
    subHeading: (
      <>
        Coding courses for <span className="font-600">Grade 1-12</span>
      </>
    ),
    stats: [
      {
        statNumber: '1 Million+',
        statSubHeading: `Students`,
      },
      {
        statNumber: '70+',
        statSubHeading: `Countries`,
      },
    ],

    ratings: [
      {
        ratingSubHeading: 'Average student & parent rating',
      },
      {
        ratingSubHeading: 'Curriculum rating',
      },
    ],
    form: {
      heading: '残席残りわずか！',
      gradeFieldPlaceholder: '学年を選択してください',
      phoneFieldLabel: '電話番号を入力してください',
      ctaText: '無料レッスンを予約する',
      hasLaptopField: {
        label: `Do you have a laptop/desktop/MacBook for the class?`,
        option1: `Yes`,
        option2: `No`,
      },
      termsAndConditions:
        '登録完了後、利用規約とプライバシーポリシーに同意したものとみなされます。保護者の方の同意を得てからお申し込みください※ 重要なお知らせはWhatsAppにてお送りいたします',
    },
  },
  partnersFold: {
    builtBySectionHeading: `Built by alumni of`,
    partnershipSectionHeading: `In partnership with`,
    stemSectionHeading: `Accredited by STEM.org`,
    backedBySectionHeading: `Backed by`,
  },
  learnToCodeFold: {
    heading: {
      normalText: '学びの成果が形になる！',
      underlinedText: '充実の認定証プログラム',
    },
    subHeading:
      '多彩な認定証でお子様の成長を形に。 ゲーム・アプリ・Web開発やデータサイエンスなど、さまざまな分野の実力を証明できます',
  },
  testimonialsFold: {
    heading: {
      normalText: '選ばれる理由 。',
      underlinedText: '受講生の声',
    },
    contents: [
      {
        name: 'レイくん',
        imageName: 'picture1',
        subheading: '小学3年生/生徒',
        content: '先生が優しく教えてくれるので、毎回の授業が楽しみです！',
      },
      {
        name: 'ライマさん',
        imageName: 'picture2',
        subheading: '小学5年生/生徒',
        content:
          'コーディングを学んで、色々なゲームを作るのが好きです。楽しくてやりがいがあり、Codingalに感謝しています！',
      },
      {
        name: 'ダイバットくん',
        imageName: 'picture3',
        subheading: '小学4年生/生徒',
        content:
          'スプライトをドラッグ＆ドロップするのが大好きです。CodingalのScratchの先生はとても知識が豊富で、いつも忍耐強く助けてくれます',
      },
      {
        name: 'イクミさん',
        imageName: 'picture4',
        subheading: '生徒保護者',
        content:
          'Codingalの体系的なコースは、息子にとってコーディングを楽しいものにしてくれました。最速で学べるベストな学習方法です！',
      },
    ],
    reviewLinkText: 'See more reviews',
  },
  whyCodingalFold: {
    heading: {
      normalText: 'Codingal',
      underlinedText: 'を選ぶ理由',
    },
    contents: [
      {
        heading: '熟練した講師による',
        coloredHeading: '個別指導',
        imgLabel: 'guided-by-expert-instructors',
        subHeading:
          'プログラミングのプロフェッショナルが、マンツーマンできめ細やかに指導いたします。',
      },
      {
        heading: '科学的根拠に基づく',
        coloredHeading: 'カリキュラム',
        imgLabel: 'powered-by-scientific-curriculum',
        subHeading:
          'BIDE、STEAM教育、ブルームの教育分類法を統合した 世界初・唯一の科学的プログラミング学習メソッドを確立しています。',
      },
      {
        heading: 'お子様に合わせた',
        coloredHeading: '学習ペース',
        imgLabel: 'pace-of-instruction-that-matches-your-learning-style',
        subHeading:
          'お子様に最適なペースで、着実に成長！ 一人ひとりの学習スタイルに合わせたオーダーメイドの学習プランで、コースの学びを最大限引き出します。',
      },
    ],
  },
  footer: {
    supprotHeading: 'お問い合わせ ご不明な点はお気軽にご連絡ください',
    copyRights: '©️ 2025 Codingal. All rights reserved.',
  },
}
